import type { IMergeFieldAttrs } from './mergeFieldToken';

/** Standard contact merge fields, copied from the legacy Token.ts placeholder set. */
export const CONTACT_MERGE_FIELDS: readonly IMergeFieldAttrs[] = [
	{ text: 'first name', value: 'contact.firstName' },
	{ text: 'last name', value: 'contact.lastName' },
	{ text: 'company name', value: 'contact.companyName' },
	{ text: 'job title', value: 'contact.jobTitle' },
	{ text: 'city', value: 'contact.address.city' },
	{ text: 'state', value: 'contact.address.stateProvince' },
];
